export const DEFAULT_WRITE_TO_US_FORM_VALUES = {
  message: '',
  email: '',
  agree: false,
  agreePolicy: false,
}
